exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-graphic[data-v-771f64bc]{\n  margin-top: 1rem;\n}\n", ""]);

// exports
